module.exports = __webpack_public_path__ + "img/SC600camera-min.84077d66.png";